import * as React from 'react';
import Box from '@material-ui/core/Box';
import {Button} from '@material-ui/core';

import useModalById from '~/customHooks/useModalById';
import {MODAL_CHAT_UNAVAILABLE} from '~/rootStore/modals/modalsIds';

import ModalBase from '../ModalBase';
import ModalBaseContent from '../ModalBaseContent';

const ModalChatUnavailable: React.FC = () => {
  const {
    isOpen: isChatUnavailableModalOpen,
    close: closeChatUnavailableModal,
    props: {beforeBtn, errorMsg},
  } = useModalById(MODAL_CHAT_UNAVAILABLE);

  const handleBeforeBtnClick = () => {
    if (beforeBtn && beforeBtn.action) {
      beforeBtn.action();
      closeChatUnavailableModal();
    }
  };

  return (
    <ModalBase
      showOkButton
      open={isChatUnavailableModalOpen}
      onClose={closeChatUnavailableModal}
      buttons={
        beforeBtn && beforeBtn.action ? (
          <Button key="button" color="primary" variant="text" onClick={handleBeforeBtnClick}>
            <Box fontWeight="normal">{beforeBtn.text}</Box>
          </Button>
        ) : undefined
      }
    >
      <ModalBaseContent title="Message Not Sent" description={errorMsg && errorMsg} />
    </ModalBase>
  );
};

export default ModalChatUnavailable;
